import { Component, OnInit } from '@angular/core';
import 'parse';
const parse: typeof Parse = require('parse');
import { SearchService } from '../service/search.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-annotations',
  templateUrl: './annotations.component.html',
  styleUrls: ['./annotations.component.less']
})
export class AnnotationsComponent implements OnInit {
  tchekId = '';
  rois: Array<any>;
  parseRois: Array<Parse.Object>;
  roiToDelete: Parse.Object;
  roiToEdit: Parse.Object;
  roiToBeDeletedIndex: number;
  _roiSeverities = {
    str: [
      '5mm',
      '10mm',
      '15mm'
    ],
    isValid: function (str) {
      for (let i = 0; i < this.str.length; i++) {
        if (this.str[i] === str)
          return true;
      }
      return false;
    }
  };
  devices = [
    { id: 0, name: 'Tous' },
  ];
  devicesSelected = 'Tous';
  isAssemblyByTchek = true;

  constructor(public _searchService: SearchService, private _router: Router) {
    this.rois = [];
    this.parseRois = [];

    if (parse.User.current().get('isSuperAdmin')) {
      this.getDetails();
    }
    const i = 1;
    this._searchService.getDevices().then(devices => {
      devices.forEach(device => {
        this.devices.push({ id: device.id, name: device.get('name') });
      });

    });
  }
  checkValue() {
    this.getDetails();
  }
  getDetails() {
    const query = new parse.Query(parse.Object.extend('Annotation'));
    query.limit(100000);
    query.ascending('tchekPtr');
    //query.equalTo('folder', this.cameraNumber);
    query.find().then((retrievedAnnotations) => {
      // console.log('retrievedAnnotations', retrievedAnnotations);
      const allPromises = [];
      const knownFolders = [];
      const listTchek = [];
      let totalAnnotation = 1;
      let numberOfTchek = -1;
      for (let i = 0; i < retrievedAnnotations.length; i++) {
        if (this.isAssemblyByTchek) {
          if (listTchek.indexOf(retrievedAnnotations[i].get('tchekPtr').id) === -1) {
            listTchek.push(retrievedAnnotations[i].get('tchekPtr').id);
            totalAnnotation = 1;
            numberOfTchek++;
            const annotation: any = retrievedAnnotations[i];
            annotation.type = retrievedAnnotations[i].get('label');
            annotation.folder = 1; //retrievedAnnotations[i].get('folder')
            annotation.sequence = 0; //retrievedAnnotations[i].get('sequence')
            annotation.tchekId = retrievedAnnotations[i].get('tchekPtr').id;
            annotation.number = totalAnnotation;
            annotation.url = '/player/' + annotation.tchekId + '/' + annotation.folder + '/0';
            this.rois.push(annotation);
          } else {
            totalAnnotation++;
            this.rois[numberOfTchek].number = totalAnnotation;
          }
        }

        /* let annotation =  retrievedAnnotations[i]
        annotation.type = retrievedAnnotations[i].get('label')
        annotation.tchekId = retrievedAnnotations[i].get('tchekPtr').id
        this.rois.push(annotation) */
      }

    }, (error) => {
      console.error('Could not retrieve annotations : ', error.code, error.message);
    });
  }
  openRoiSlider(roi, event) {
    window.open(roi.url, '_blank');
  }

  ngOnInit() {
  }

  handleSearchTriggered(activeFilters?: Array<string>) {
    // Reactivate loading spinner until search returns a result
    /* this.isLoading = true;
    // Reset content for list view and grid view
    this.tcheks = [];
    this.vehicles = []; */
    //console.log('handleSearchTriggered');
  }

  filterWithSearchResults(filteredTcheks) {
    //console.log('filterWithSearchResults');
  }
  onChangeSelect(e) {

  }
}



// WEBPACK FOOTER //
// ./src/app/annotations/annotations.component.ts